import React from "react";
import "./sidePanel.scss";
import { Button, Timeline } from "antd";
// import DemoTextIcon from "components/svg-icons/demo-icon";
import AccordionDownArrowIcon from "components/svg-icons/accordion-down-arrow-icon";
import AccordionUpArrowIcon from "components/svg-icons/accordion-up-arrow-icon";
// import { SmileOutlined } from "@ant-design/icons";
import ClockIcon from "components/svg-icons/clock-icon";

interface SidePanelProps {
  isOpen: boolean;
}

// eslint-disable-next-line react/function-component-definition
const SidePanel: React.FC<SidePanelProps> = ({ isOpen = false }) => {
  // return (
  //   <div id="sidePanel">
  //     <div className={`side-panel ${isOpen ? "open" : ""}`}>
  //       <button onClick={togglePanel} className="close-btn" type="button">
  //         Close
  //       </button>
  //       <div className="side-panel-content">
  //         <h2>Side Panel</h2>
  //         <p>Under construction</p>
  //       </div>
  //     </div>
  //   </div>
  // );
  const [isGeneralInfoOpen, setGeneralInfoOpen] = React.useState(true);
  const [isLinksOpen, setLinksOpen] = React.useState(true);
  const [isProgressOpen, setProgressOpen] = React.useState(true);

  const headerStyle =
    "flex justify-between items-center bg-gray-100 px-4 py-2 rounded cursor-pointer";

  return (
    <div id="sidePanel">
      <div className={`side-panel ${isOpen ? "open" : ""} scroll-container`}>
        {/* Header Section */}
        <div className="bg-white">
          <header
            className="p-4 flex items-start justify-between"
            style={{ paddingRight: "0px" }}
          >
            {/* Left Section */}
            <div className="flex flex-col">
              <div className="flex items-center">
                <div className="w-2 h-10 bg-red-500 mr-4" />
                <h3 className="text-sm ">
                  5675 - Air Handler Unit - Product Data
                </h3>
              </div>
              <div className="text-gray-500 text-sm ml-6">Submittal</div>
            </div>

            {/* Right Section */}
            <Button className="text-sm no-button-border">x</Button>
          </header>

          {/* Header Details Section */}
          <div
            className="bg-gray-100 p-4 rounded-md max-w-md mx-auto margin-spacing"
            style={{ paddingBottom: "5px" }}
          >
            <div className="grid grid-cols-2 gap-4 text-sm">
              {/* Start Date */}
              <div>
                <p
                  className="text-gray-500 font-medium"
                  style={{ marginBottom: "0px" }}
                >
                  Start
                </p>
                <p className="text-black ">01 - 23 - 2025</p>
              </div>

              {/* Projected Finish */}
              <div>
                <p
                  className="text-gray-500 font-medium"
                  style={{ marginBottom: "0px" }}
                >
                  Projected Finish
                </p>
                <p className="text-black ">03 - 12 - 2025</p>
              </div>

              {/* Status */}
              <div>
                <p
                  className="text-gray-500 font-medium"
                  style={{ marginBottom: "0px" }}
                >
                  Status
                </p>
                <p className="text-black ">In Progress, Delayed</p>
              </div>

              {/* Risk */}
              <div>
                <p
                  className="text-gray-500 font-medium"
                  style={{ marginBottom: "0px" }}
                >
                  Risk
                </p>
                <p className="text-red-500 ">HIGH</p>
              </div>
            </div>
          </div>
          <div className="p-4 max-w-md mx-auto border">
            <div className="text-gray-500">Actions</div>
            <div className="mt-2 flex gap-2">
              <Button className="px-3 py-1 bg-blue-500 text-white rounded">
                Modify Links
              </Button>
              <Button className="px-3 py-1 bg-gray-300 rounded">
                Edit in Details Page
              </Button>
            </div>
          </div>

          {/* General Information Section */}
          <div>
            <div
              className={headerStyle}
              role="button"
              tabIndex={0}
              onClick={() => setGeneralInfoOpen(!isGeneralInfoOpen)}
              onKeyPress={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  setGeneralInfoOpen(!isGeneralInfoOpen);
                }
              }}
              style={{ paddingBottom: "0px" }}
            >
              <h2
                className="text-sm items-center justify-between"
                style={{ marginBottom: "10px" }}
              >
                General Information
              </h2>
              <span
                className="text-sm items-center justify-between"
                style={{ marginBottom: "5px" }}
              >
                {isGeneralInfoOpen ? (
                  <AccordionUpArrowIcon />
                ) : (
                  <AccordionDownArrowIcon />
                )}
              </span>
            </div>
            {isGeneralInfoOpen && (
              <div className="p-4 mx-auto text-sm">
                <div>
                  <p
                    className="text-gray-500 font-medium"
                    style={{ marginBottom: "0px" }}
                  >
                    Spec
                  </p>
                  <p className="text-black ">
                    260923 - Lighting Control Devices
                  </p>
                </div>
                <div>
                  <p
                    className="text-gray-500 font-medium"
                    style={{ marginBottom: "0px" }}
                  >
                    Type
                  </p>
                  <p className="text-black ">Product Data</p>
                </div>
                <div>
                  <p
                    className="text-gray-500 font-medium"
                    style={{ marginBottom: "0px" }}
                  >
                    Deadline
                  </p>
                  <p className="text-black ">10-23-25</p>
                </div>
              </div>
            )}
          </div>

          {/* Links Section */}
          <div>
            <div
              className={headerStyle}
              role="button"
              tabIndex={0}
              onClick={() => setLinksOpen(!isLinksOpen)}
              onKeyPress={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  setLinksOpen(!isLinksOpen);
                }
              }}
              style={{ paddingBottom: "5px" }}
            >
              <h2 className="text-sm items-center justify-between">Links</h2>
              <span className="text-sm items-center justify-between">
                {isLinksOpen ? (
                  <AccordionUpArrowIcon />
                ) : (
                  <AccordionDownArrowIcon />
                )}
              </span>
            </div>
            {isLinksOpen && (
              <div className="p-4 mx-auto text-sm">
                <p className="flex items-center gap-2">
                  <span className="material-icons text-gray-500">link</span>
                  <span>330 - Air Handlers</span>
                </p>
                <p className="flex items-center gap-2">
                  <span className="material-icons text-gray-500">link</span>
                  <span>330 - WIRING</span>
                </p>
              </div>
            )}
          </div>

          {/* Progress Section */}
          <div>
            <div
              className={headerStyle}
              role="button"
              tabIndex={0}
              onClick={() => setProgressOpen(!isProgressOpen)}
              onKeyPress={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  setProgressOpen(!isProgressOpen);
                }
              }}
              style={{ paddingBottom: "4px" }}
            >
              <h2 className="text-sm " style={{ marginBottom: "5px" }}>
                Progress
              </h2>
              <span className="text-sm items-center justify-between">
                {isProgressOpen ? (
                  <AccordionUpArrowIcon />
                ) : (
                  <AccordionDownArrowIcon />
                )}
              </span>
            </div>
            {isProgressOpen && (
              <div className="p-4 mx-auto text-sm">
                <Timeline>
                  <Timeline.Item color="green">
                    <h4>Assigned to Subcontractor</h4>
                    <h5>Actual Date: 30-01-2025</h5>
                  </Timeline.Item>
                  <Timeline.Item color="green">
                    <h4>Submitted by Subcontractor</h4>
                    <h5>Projected Date: 31-01-2025</h5>
                  </Timeline.Item>
                  <Timeline.Item color="red" dot={<ClockIcon />}>
                    <h4>Submitted for Design Review</h4>
                    <h5>Projected Date: 12-02-2025</h5>
                  </Timeline.Item>
                  <Timeline.Item>
                    <h4>Design Review Complete</h4>
                    <h5>Projected Date: 14-02-2025</h5>
                  </Timeline.Item>
                  <Timeline.Item color="gray">
                    <h4>Submittal Distributed</h4>
                    <h5>Projected Date: 16-02-2025</h5>
                  </Timeline.Item>
                </Timeline>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SidePanel;
